import { mergeAllUrls } from 'functions/mergeAllUrls'
export const passwordResetPath = 'password-reset'
export const passwordResetSuccessPath = 'success'
export const passwordResetFailPath = mergeAllUrls('fail', ':reason')
